'use client'

import TrackButton, { TrackButtonResponsiveContent } from '@component/card/listings/track'
import { joinStr } from '@utils'
import classNames from 'classnames'
import FreeAppraisalButton from './freeAppraisal'

export default function PropertyBar({
  data,
  barClick
}) {

  return (
    <div className='py-18 flex items-center justify-between gap-x-8'>
      <Address className='text-sm md:hidden'>{data.street}</Address>
      <Address className='text-lg hidden md:block'>{joinStr([data.street, data.suburb], ', ')}</Address>
      <FreeAppraisalButton data={data} onClick={barClick}></FreeAppraisalButton>
      <TrackButton
        data={data}
        signupSource='Track_Home'
        dark
        content={
          <TrackButtonResponsiveContent
            mobileStopText='Stop track'
            mobileTrackText='Track'
            stopText='Stop tracking'
            trackText='Track this property'
          ></TrackButtonResponsiveContent>
        }
        onClick={barClick}
      ></TrackButton>
    </div>
  )
}

// address
function Address({
  className,
  children
}) {

  return (
    <address className={classNames('not-italic line-clamp-2', className)}>{children}</address>
  )
}